import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/fleet")({
  staticData: { title: "Fleet" },
  component: () => <Outlet />,
})
